import React from "react";
import { DOMNode, attributesToProps, domToReact } from "html-react-parser";
import { Bleeder } from "../../components/Bleeder";
import { createReplacer } from "./Replacer";

const wrapBlockquoteBleed = createReplacer({
  supports({ name }) {
    return name === "blockquote";
  },
  replace({ children, attribs }, options) {
    const props = attributesToProps(attribs);

    return (
      <Bleeder left={true} right={false} bg="bg-black">
        <blockquote {...props}>
          {domToReact(children as DOMNode[], options)}
        </blockquote>
      </Bleeder>
    );
  },
});

export default wrapBlockquoteBleed;
